// Auto-generated by scripts/write-git-version.mjs
export const gitVersion = {
  "sha": "bebd07d252dadb6661eab9831a789c9d2c1e7ec8",
  "branch": "main",
  "dirty": false,
  "buildTime": "2026-01-26T21:27:18.295Z"
};
export default gitVersion;
